<template>
  <div v-show="isModalOpen" class="QuizModuleDialog">
    <div class="dialogPane">
      <CloseButton @click="close" class="closeButton" />
      <QuizModule v-bind="{ content }" />
    </div>
  </div>
</template>

<script>
import bodyScroll from '~/lib/bodyScroll.js'

import CloseButton from '~/vue-components/shared/CloseButton.vue';
import QuizModule from '../../polymorphic-page/QuizModule/index.vue'

export default {
  components: {
    CloseButton,
    QuizModule,
  },
  emits: ['closed'],
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      isModalOpen: false,
    }
  },
  methods: {
    // This method can be called by the parent component to display the modal
    showModal() {
      bodyScroll.lock()
      this.isModalOpen = true
    },
    close() {
      bodyScroll.unlock()
      this.isModalOpen = false
      this.$emit('closed')
    }
  },
}
</script>

<style scoped>

.QuizModuleDialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 50;
  display: flex;
  align-items: center;
}

.closeButton {
  --main-color: white;
  position: absolute;
  top: var(--spacing-5);
  right: var(--spacing-5);
  z-index: 10;
}

@media (--screen-lg) {

  .QuizModuleDialog {
    padding: var(--spacing-7);
    justify-content: center;
  }

  .dialogPane {
    position: relative;
    border-radius: var(--border-radius);
    width: 70rem;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
